import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.targetExecution || initialState;

export const selectTargetExecution = createSelector(
  [selectSlice],
  state => state,
);

export const selectTargetExecutionReport = createSelector(
  [selectSlice],
  state => state.accuracy,
);
